import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useDocumentPDF(documentKey: string) {
  return useQuery({
    ...apiClient.getDocumentPdfUrlDocumentsKeyPdfGetOptions({
      path: {
        key: documentKey,
      },
    }),
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  })
}
